import React from 'react';
import rehydrateToPortals from './rehydrateToPortals';
import { AppRootProps, IAppRootState } from './types';
import { LoggerContext } from '@dcl-ue/app-logger';

class AppRoot extends React.Component<AppRootProps, IAppRootState> {
  public static readonly contextType = LoggerContext;

  public state = {
    portals: [],
  };

  public componentDidMount() {
    this.rehydrateComponents();
  }

  private readonly rehydrateComponents = () => {
    const { onRehydration } = this.props;

    rehydrateToPortals().then((rehydratedPortals) => {
      this.setState({ portals: rehydratedPortals as React.ReactPortal[] });
      if (onRehydration) {
        onRehydration(rehydratedPortals as React.ReactPortal[]);
      }
    });
  };

  public render() {
    const { children } = this.props;
    const { portals } = this.state;

    return (
      <>
        {portals}
        {children}
      </>
    );
  }
}

export default AppRoot;
